import { Injectable } from '@angular/core';
import { Router, NavigationEnd, Event } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { StatusBar } from '@awesome-cordova-plugins/status-bar/ngx';
import { DeviceService } from './device.service';

@Injectable({
  providedIn: 'root'
})
export class NavigationStateService {
  private _urlState: BehaviorSubject<UrlState>;

  constructor(
    private router: Router,
    private statusBar: StatusBar,
    private deviceService: DeviceService
  ) {
    this._urlState = new BehaviorSubject({
      previous: '',
      current: this.router.url
    });
    router.events.subscribe((event: Event): void => {
      if (event instanceof NavigationEnd) {
        const state: UrlState = {
          previous: this._urlState.value.current,
          current: event.urlAfterRedirects
        };
        this._urlState.next(state);
        if (this.deviceService.isCordova()) {
          this.changeStatusBar(state.current);
        }
      }
    });
  }

  public get url(): BehaviorSubject<UrlState> {
    return this._urlState;
  }
  public getPreviousUrl(): string {
    return this._urlState.value.previous;
  }
  public getCurrentUrl(): string {
    return this._urlState.value.current;
  }

  private changeStatusBar(currentUrl: string): void {
    if (!currentUrl) {
      this.statusBar.backgroundColorByHexString('#FFFFFF');
    }

    if (currentUrl.includes('fast-track')) {
      this.statusBar.overlaysWebView(false);
      this.statusBar.backgroundColorByHexString('#ea0a2a');
    } else if (currentUrl.includes('virtual-tax-pro/')) {
      this.statusBar.overlaysWebView(false);
      this.statusBar.backgroundColorByHexString('#141826');
      this.statusBar.styleLightContent();
    } else {
      if (this.deviceService.isIOS()) {
        this.statusBar.overlaysWebView(true);
      } else {
        this.statusBar.overlaysWebView(false);
      }
      this.statusBar.backgroundColorByName('white');
      this.statusBar.styleDefault();
    }
  }
}

export interface UrlState {
  previous: string;
  current: string;
}
